export default __webpack_public_path__ + "static/media/field-pulse-logo.5395689e.svg";